<div class="toast"
  [style.visibility]="(visible || animate) ? 'visible' : 'hidden'"
  >
  @if ((visible || animate)) {
    <div class="message"
      [ngClass]="[level, animate ? (visible ? 'fade-in' : 'fade-out') : '']"
      (animationend)="onAnimationEnd()"
      (click)="hide()"
      >
      <mat-icon svgIcon="toast"></mat-icon>
      {{ message | translate }}
    </div>
  }
</div>
